/**
 * The framing guide the patient sees drawn over their own camera preview: one large circle, with
 * everything outside it dimmed. It is what the start screen and the scanning screen mean by "the
 * outline".
 *
 * A circle rather than the head-and-shoulders silhouette this replaced (docs/decisions.md D-49). The
 * circle sits where a face has to be for the vendor's own distance codes - `W-RES-079` too far,
 * `W-RES-080` too close (mindset-events.ts) - to stop firing, so the viewBox below (315x382) is also
 * the aspect ratio the preview frame is given in scanning-screen.tsx, and the two are one decision.
 *
 * **Inline, rather than an `<img src>`.** An asset is a second request whose failure is silent in the
 * worst place: a deploy that forgets `public/` leaves a patient with no guide and nothing goes red.
 * Inline, the artwork cannot go missing separately from the screen that renders it, and the
 * component test proves the guide rather than an `<img>` tag.
 *
 * `aria-hidden`: what it communicates is already said in words directly above it.
 */
export function FaceGuideMask({ className }: { readonly className?: string }) {
  return (
    <svg
      viewBox="0 0 315 382"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
    >
      <path
        fillRule="evenodd"
        d="M0 0H315V382H0Z M157.5 54 a122 122 0 1 0 0 244 a122 122 0 1 0 0 -244Z"
        fill="black"
        fillOpacity="0.45"
      />
      <circle cx="157.5" cy="176" r="122" stroke="white" strokeWidth="4" strokeOpacity="0.9" />
    </svg>
  )
}
